if ( jQuery('.counter-rate').length ) {
  gsap.registerPlugin(ScrollTrigger) 
  var cpt = 1;

  jQuery('.counter-rate').each(function( index ) {
    // Récupération des valeurs de départ et de fin et conversion en nombres à virgule flottante
    var currentCounterAnime = jQuery(this).find('.counter-anime');
    var startVal = parseFloat(currentCounterAnime.data('start-val'));
    var endVal = parseFloat(currentCounterAnime.data('end-val'));

    // Vérifier si data-fraction est spécifié
    var fractionAttr = currentCounterAnime.data('fraction');
    var fractionMin, fractionMax;
    var isFractionSpecified = false;

    if (fractionAttr) {
      var fractionRange = fractionAttr.split('-');
      fractionMin = parseFloat(fractionRange[0]);
      fractionMax = parseFloat(fractionRange[1]);
      isFractionSpecified = true;
    }

    // Déterminer si les décimales doivent être affichées
    var hasDecimals = currentCounterAnime.data('decimal');

    // Objet pour GSAP
    var Cont = { val: startVal };


    
    // Animation avec GSAP
    gsap.to(Cont, {
      val: isFractionSpecified ? startVal + ((endVal - fractionMin) / (fractionMax - fractionMin)) * (fractionMax - fractionMin) : endVal,
      onUpdate: function () {
        // S'assurer que Cont.val est un nombre avant d'utiliser toFixed ou Math.round
        if (typeof Cont.val === "number") {
          // Affichage conditionnel en fonction de hasDecimals
          currentCounterAnime.html( hasDecimals ? Cont.val.toFixed(2) : Math.round(Cont.val).toString());
        } else {
          // console.error("Cont.val n'est pas un nombre:", Cont.val);
        }
      },
      duration: 1.5,
      ease: "ease",

      scrollTrigger: {
        trigger: currentCounterAnime.data('trigger'),
        // markers: true,
        start: "-35% center",
        end: "-55% bottom",
        toggleActions: "play play reverse reverse"
      }

    });


    if ( currentCounterAnime.data('type') === 'arc' ||  currentCounterAnime.data('type') === 'line') {
      // Calculer la fraction de l'animation correspondante
      // En considérant que 1 est 0% et 9 est 100%
      var fraction = (endVal - fractionMin) / (fractionMax - fractionMin);
      
      // Sélectionner le chemin
      var chemin = currentCounterAnime.data('svg');

      // Calculer la longueur du chemin
      var longueur = jQuery(this).find(chemin).get(0).getTotalLength();

      // Définir stroke-dasharray et initialiser stroke-dashoffset
      jQuery(this).find(chemin).css('strokeDasharray', Math.round(longueur));
      jQuery(this).find(chemin).css('strokeDashoffset', Math.round(longueur));

      // Animer avec GSAP jusqu'à la fraction calculée de la longueur totale
      gsap.to( jQuery(this).find(chemin), {
        strokeDashoffset: longueur * (1 - fraction),
        duration: 2,
        ease: "ease",

        scrollTrigger: {
          trigger: currentCounterAnime.data('trigger'),
          // markers: true,
          start: "-35% center",
          end: "-55% bottom",
          toggleActions: "play play reverse reverse"
        }

      });
    }

    if (currentCounterAnime.data('type') === 'star') {
      // Récupération des valeurs pour le calcul de la fraction
      var fractionAttr = currentCounterAnime.data('fraction');
      var fractionRange = fractionAttr.split('-');
      var fractionMin = parseFloat(fractionRange[0]);
      var fractionMax = parseFloat(fractionRange[1]);
      var endVal = parseFloat(currentCounterAnime.data('end-val'));

      // Calculer la fraction de l'animation correspondante
      var fraction = (endVal - fractionMin) / (fractionMax - fractionMin);

      // Sélectionner l'élément SVG à animer
      var starElement = jQuery(this).find(currentCounterAnime.data('svg'));  
      
      
      var rename = jQuery(this).find('.star-rename');
      
      rename.attr('id', 'test' + cpt);
      rename.closest('.star-rename').attr('mask', 'url(#test' + cpt + ')');
      cpt = cpt + 1;
      
      var finalWidth = 217 * fraction;


      // Animation avec GSAP pour la largeur
      gsap.to(starElement, {
          attr: { width: finalWidth },
            duration: 2,
            ease: "ease",

            scrollTrigger: {
              trigger: currentCounterAnime.data('trigger'),
              // markers: true,
              start: "-35% center",
              end: "-55% bottom",
              toggleActions: "play play reverse reverse"
            }
      });
    }
  });
}
